import { useDispatch } from 'react-redux';
import A from './ActionCreators';
import Tooltip from '@material-ui/core/Tooltip';
import { toggleStyleProperties } from './toolbarOrder';
import debounce from './debounce';
import ColorPicker from './ColorPicker';

export default function ColorToolbarItem({
  item,
  className,
  selectedFigureItems,
  unifiedGroup,
  figurePanelId
}){




  const dispatch = useDispatch();

  let styleProperty = item.styleProperty;
  let valueToSet = item.valueToSet;
  let currentValue = unifiedGroup.style[ styleProperty ];

  let selected = valueToSet === currentValue ? "selected" : "";

  if(item.valueToSet === 'bold'){
  }

  

  const debouncedChange = debounce((value,selectedFigureItems) => {

    let args = {
      figureItems:selectedFigureItems,
      figurePanelId,
      style:{
        [item.styleProperty]:value
      }
    }
    dispatch(A.setCellsValue(args))

  },100)

  let defaultColor;
  if( selectedFigureItems?.cells ){
    defaultColor = "#000000";
  }else{
    defaultColor = "#ffffff"; 
  }

  if( item.styleProperty === "background" ){
    defaultColor = null;
  }


  return (
    <div 
      style={{
        borderRadius:'5px',
        position:'relative',
        width:240,
      }}
      class={selected+" toolbar-button"}
    >
      <ColorPicker {...{
        color:currentValue,
        onChange:(color) => {
          if( item.onChange ){
            item.onChange(color);
            return;
          }


          let args = {
            figureItems:selectedFigureItems,
            figurePanelId,
            style:{
              [item.styleProperty]:color
            }
          }
          dispatch(A.setCellsValue(args))
        },
        defaultColor
      }}/>
    </div>
  )


}
